import React, { useEffect, useState } from "react";
import "./setModal.css";
import LongCard from "../../cards/longCard/LongCard";
import {
  Box,
  Button,
  Grid,
  Grow,
  Modal,
} from "@mui/material";
import { useGlobalContext } from "../../../../context/GlobalContext";
import { ReactComponent as Close } from "../../../../assets/icons/boxed-close.svg";

const SetModal = ({ openModal, handleClose, data }) => {
  const { handleRemoveFromCart } = useGlobalContext();

  const [cartData, setCartData] = useState([]);
  const [apply, setApply] = useState(true);

  useEffect(() => {
    setCartData(data);
  }, [data]);

  useEffect(() => {
    if (cartData?.length < 1) {
      handleClose();
    }
    return(()=>{
      setApply(true)
    })
  }, [cartData]);

  const handleDeleteCard = (data) => {
    setCartData((prevData) =>
      prevData?.filter((item) => item?.styleNumber !== data?.styleNumber)
    );
    handleRemoveFromCart(data);
  };  

  return (
    <Modal
      open={openModal}
      onClose={handleClose}
      sx={{ display: "flex", justifyContent: "center" }}
    >
      <Grow in={openModal}>
        <Box
          sx={{
            position: "absolute",
            top: "12%",
            background: "#141414",
            borderRadius: ".4vw",
            outline: "none",
            border: "none",
            width: "51vw",
            height: "75vh",
          }}
          marginX="auto"
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: ".5vw",
              padding: "1.2vw",
              flexGrow: 1,
              width: "100%",
              height: "95%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <Close cursor="pointer" onClick={handleClose} />
            </Box>
            <div style={{ padding: ".5vw", overflowY: "scroll" }}>
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                sx={{
                  flex: "1 1 1",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  gap: "1.5vw",
                  rowGap: ".9vw",
                }}
                className="Grid-padding"
              >
                {data?.map(
                  (design) =>
                    design?.quantityData?.map((item) => (
                      <LongCard
                        key={item?.key}
                        data={design}
                        modifyData={item}
                        modify={false}
                        setIcon={false}
                        onDelete={() => handleDeleteCard(design)}
                        setApply={setApply}
                        apply={apply}
                      />
                    ))
                )}
              </Grid>
            </div>
          </Box>
          <Button
            sx={{
              width: "100%",
              height: "2.4vw",
              background: "#50C878",
              color: "#000000",
              fontSize: ".8vw",
              fontWeight: "600",
              fontFamily: "Poppins",
              borderRadius: 0,
              borderBottomLeftRadius: ".4vw",
              borderBottomRightRadius: ".4vw",
            }}
            onClick={()=>{
              setApply(false);
              setTimeout(()=>{
                handleClose();
              },200)
            }}
          >
            Apply
          </Button>
        </Box>
      </Grow>
    </Modal>
  );
};

export default SetModal;
